module.exports = __webpack_public_path__ + "img/taoyuan-1.82a21cc7.jpg";